import React from 'react';

interface BudgetIconThreeProps {
  width?: number;
  height?: number;
  strokeColor?: string;
}

const BudgetIconThree: React.FC<BudgetIconThreeProps> = ({ width = 50, height = 50, strokeColor = '#495057' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3459_11107)">
        <rect x="50" width="13" height="31" rx="4" transform="rotate(90 50 0)" fill={strokeColor} />
        <rect x="50" y="19" width="13" height="31" rx="4" transform="rotate(90 50 19)" fill={strokeColor} />
        <rect x="13" y="32" width="13" height="32" rx="4" transform="rotate(-180 13 32)" fill={strokeColor} />
        <rect x="50" y="37" width="13" height="50" rx="4" transform="rotate(90 50 37)" fill={strokeColor} />
      </g>
      <defs>
        <clipPath id="clip0_3459_11107">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BudgetIconThree;
